import React, { useContext, useEffect } from "react";
import ReactModal from "react-modal";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";

function VueGlobale() {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    content: {
      borderRadius: "12px",
      flex: "0 0 984px",
      overflow: "hidden",
    },
  };

  function closeModal() {
    appDispatch({ type: "CLOSE_VUE_GLOBALE" });
  }

  ReactModal.setAppElement("#root");

  return (
    <ReactModal
      isOpen={appState.vueGlobaleIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Vue globale"
      className="modal-window vue-globale"
    >
      <button onClick={closeModal} className="modal-window__fermer">
        <span className="visually-hidden">Fermer</span>
      </button>
      <div className="vue-globale__container">
        <img
          className="vue-globale__fond"
          src={`images/${appState.livre.isbn}/vue-globale.png`}
          alt=""
        />
        {appState.chapitres.map((chapitre, chapitreIdx) => (
          <div
            className={`vue-globale__chapter vue-globale__chapter--${
              appState.status[chapitreIdx].locked ? "locked" : "unlocked"
            } vue-globale__chapter--${chapitre.id}`}
          >
            {chapitre.id}
          </div>
        ))}
        <div
          className={`vue-globale__coffre vue-globale__coffre--${
            appState.allChaptersUnlocked ? "open" : "closed"
          }`}
        ></div>
      </div>
    </ReactModal>
  );
}

export default VueGlobale;
